<!-- prettier-ignore -->

  <ion-header no-border>
    <div class="cicerone-header" [ngClass]="{'no-touch': disableTouch()}">
      
      <div class="cicerone-header__logo">
        @if(!tools.isTechEditMode()){
            @if (!tools.isRegisterMode() && !isInfoRoutePage()){
               @if(showBackButton() || isBackDistributor()){
                <ion-icon (click)="goBack()" name="arrow-back-outline" attr.aria-label="{{ 'Atrás' | translate }}"></ion-icon>  
               }
            } 
            @if(rest?.device?.logo?.value){
              <img draggable="false" [src]="rest?.device?.logo?.value" (click)="goToHome()" (error)="tools.onImageError($event)" [ngClass]="{'no_click': isInfoRoutePage()}" alt="{{'Inicio' | translate}}"  />
            }
        }
        @else {
            <span>{{'Modo Edición' | translate}}</span>
        }
      </div>
  
      <div class="cicerone-header__fab">
        <!--@if(breakpointsService.isMobile() && passportEnabled()){
          <div (click)="handlePassportClick()" class="passport-fab-icon">
            <passport-icon />
          </div>
        }-->

        @if(tools.isTechEditMode()){
          <header-tech-update />
        }
  
        @if(!tools.isRegisterMode() && tools.isApp && !tools.isTechEditMode() && !tools.isTechMode() && !isInfoRoutePage()){
          <header-user-menu />
        }
  
        @if(!isWebApp() || (isWebApp() && languages()?.length > 1)){
          <header-languages [clientId]="currentClientId" />
        }
  
        @if(tools.isTechMode()){
          <header-tech-logout />
        }
      </div>
  
    </div>
  </ion-header>

